import { Provider } from 'react-redux';
import { store } from './store';
import AppInitializer from './AppInitializer';
import { AppRoutes } from './router';
// import ShopListPage from '@/pages/ShopListPage';

export default function App() {
  return (
    <Provider store={store}>
      <AppInitializer>
        <AppRoutes />
      </AppInitializer>
    </Provider>
  );
}